/**
 * The OPTIONAL marketing opt-in on the signup form — unchecked by default and
 * separate from the Terms checkbox. Only a person who ticks it becomes a
 * marketable contact in BuzzBit X's own workspace (server signupBridge); the
 * transactional product emails every account gets do not depend on it.
 */
import React from 'react';
import { t } from '@/i18n';
import { AuthCheckbox, AuthLabel } from '../auth/authFormControls';

interface MarketingOptInProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const MarketingOptIn: React.FC<MarketingOptInProps> = ({ checked, onChange, disabled }) => (
  <div className="flex items-start space-x-2">
    <AuthCheckbox
      id="marketingOptIn"
      checked={checked}
      onCheckedChange={onChange}
      disabled={disabled}
      className="mt-0.5"
    />
    <AuthLabel
      htmlFor="marketingOptIn"
      className="cursor-pointer text-sm font-normal leading-tight text-gray-700"
    >
      {t('signup.marketingOptIn')}
      <span className="block text-xs text-gray-500">{t('signup.marketingOptInHint')}</span>
    </AuthLabel>
  </div>
);
